import React from 'react';
import { MarkerPopUpProps } from '@src/v3/interfaces/components/coreUI/googleMap';
import PropertyCardCompact from '@src/v3/components/propertyCard/propertyCardCompact';
import { APP_ROUTE } from '@src/v3/constants/routes';

const MarkerPopUp = ({
  image = '',
  address = '',
  locationDetails = '',
  bedrooms = 0,
  bathrooms = 0,
  squareFootage = 0,
  cost = 0,
  netEffectiveRent = 0,
  property,
  totalProperties = 1,
}: MarkerPopUpProps) => {
  const openModalUrl = `${APP_ROUTE.PROPERTY?.replace(
    '#PROPERTY_ID#',
    property?.id
  )}`;
  // Show singleUnit only when there's exactly 1 property, otherwise show default
  const variant = totalProperties === 1 ? 'singleUnit' : 'default';

  return (
    <PropertyCardCompact
      image={image}
      address={address}
      locationDetails={locationDetails}
      price={cost}
      netEffectiveRent={netEffectiveRent}
      bedroom={bedrooms}
      bathroom={bathrooms}
      squareFootage={squareFootage}
      href={openModalUrl}
      variant={variant}
    />
  );
};

export default MarkerPopUp;
